import { render } from "./SocialLinks.vue?vue&type=template&id=74fe8106&scoped=true&ts=true"
import script from "./SocialLinks.vue?vue&type=script&lang=ts"
export * from "./SocialLinks.vue?vue&type=script&lang=ts"

import "./SocialLinks.vue?vue&type=style&index=0&id=74fe8106&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74fe8106"]])

export default __exports__